import { request } from '../lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll () {
  return request({
    url: 'company',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `company`,
    method: 'get',
    params: queriesParams
  })
}

/**
 * @param {Object} company
 * @param {String} company.name
 * @param {Array<Number>} company.systemmodules
 * @returns {Promise<Object>}
 */
export function add (company) {
  return request({
    url: 'company',
    method: 'post',
    data: company
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `company/${id}`,
    method: 'get'
  })
}

/**
 * @param {Number} id
 * @param {Object} data
 * @param {String} data.name
 * @returns {Promise<Object>}
 */
export function edit (id, data) {
  return request({
    url: `company/${id}`,
    method: 'patch',
    data
  })
}
